import { z } from "zod";

type DateAgnosticTime = { hour: number; minute: number };
const dateAgnosticTimeZodSchema: z.ZodSchema<DateAgnosticTime> = z.object({
    hour: z.number().min(0).max(23),
    minute: z.number().min(0).max(59),
});

//Used if minute is greater than 59 to solve problems with old discount_conditions
const dateAgnosticTimeRelaxedMinuteZodSchema: z.ZodSchema<DateAgnosticTime> =
    z.object({
        hour: z.coerce.number().min(0).max(23),
        minute: z.coerce.number().min(0),
    });

export type { DateAgnosticTime };
export { dateAgnosticTimeZodSchema, dateAgnosticTimeRelaxedMinuteZodSchema };
